export let mergeLanguageFiles = async (language: string, country: string | null) => {
    let mainLanguage = await import(`../../static/lang/${language}.json`)

    if (!country) return mainLanguage.default || mainLanguage

    try {
        let englishCountryLanguage = await import(`../../static/lang/en-${country}.json`)

        if (language === 'en')
            return mergeObjects(mainLanguage.default || mainLanguage, englishCountryLanguage.default || englishCountryLanguage)
        else {
            let countryLanguage = await import(`../../static/lang/${language}-${country}.json`)
            let mainLanguageOverrided = mergeObjects(mainLanguage.default || mainLanguage, englishCountryLanguage.default || englishCountryLanguage)
            return mergeObjects(mainLanguageOverrided, countryLanguage.default || countryLanguage)
        }
    } catch (e) {
        console.warn("Following language not found:", e?.message)
        return mainLanguage.default || mainLanguage
    }
}

export function mergeObjects(mainJson, specificJson) {
    for (let prop in specificJson) {
        let value = specificJson[prop]
        if ((typeof value) == 'object') {
            if (!mainJson[prop]) mainJson[prop] = {}
            mergeObjects(mainJson[prop], specificJson[prop])
        } else {
            mainJson[prop] = value
        }
    }
    return mainJson
}
